module.exports = __webpack_public_path__ + "media/bootstrap-icons/inboxes-a08b20be.svg";